import { render, staticRenderFns } from "./SvgFacebook.vue?vue&type=template&id=7c780663"
import script from "./SvgFacebook.vue?vue&type=script&setup=true&lang=ts"
export * from "./SvgFacebook.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports